import CustomerNewTicket from "./CustomerNewTicket";
import CustomerNewTicketProvider from "./CustomerNewTicketContext";

let Index = () => {

    return (
        <CustomerNewTicketProvider>
            <CustomerNewTicket />
        </CustomerNewTicketProvider>
    );
}


export default Index;